<div *ngIf="control?.invalid && (control?.dirty || control?.touched) && !field?.hideErrorsUntilSubmit" class="text-danger">
  <div class="alert-dang" *ngFor="let error of errorMessages">{{ error }}</div>
</div>
